





























































































import { Component, Vue, Watch } from "vue-property-decorator";
import QRCode from "qrcodejs2";
@Component({
  components: { QRCode },
})
export default class Home extends Vue {
  public modelShow = false;
  public channel: any = "";
  public os = "unknown";
  public pcModalTip = false;
  public pcModalBtnStr = "Windows";
  public async getDeviceOS() {
    const userAgent = navigator.userAgent;
    let os = "unknown";
    if (userAgent.indexOf("Windows NT") > -1) os = "Windows";
    if (userAgent.indexOf("Windows") > -1) os = "Windows";
    if (userAgent.indexOf("Mac") > -1) os = "Mac";
    this.os = os;
  }
  public mounted() {
    this.getDeviceOS();
  }
  public show() {
    if (this.$route.query.channel) this.channel = this.$route.query.channel;
    if (this.channel == "shunwan") {
      this.getQrcode(
        "iosweChatQrcode",
        this.$store.state.home.downList.shunwan.ios_down_url
      );
      this.getQrcode(
        "anweChatQrcode",
        // this.$store.state.home.downList.shunwan.android_down_url
        "https://m.996box.com/shunwan.html"
      );
    }
    if (this.channel == "996") {
      this.getQrcode(
        "iosweChatQrcode",
        this.$store.state.home.downList.channel_996.ios_down_url
      );
      this.getQrcode(
        "anweChatQrcode",
        // this.$store.state.home.downList.shunwan.android_down_url
        "https://m.996box.com/shunwan.html?channel=996"
      );
    }
    this.modelShow = true;
  }
  public eventReporting(type) {
    this.$fn.bPoint({
      name: "homepage_download",
      type: "track",
      properities: {
        type,
      },
    });
  }
  public downLoadWindows(download) {
    if (this.os === "Windows" || download) {
      const localInfoStr: any = localStorage.getItem("LOCAL_BOXDOWNLOADURL");
      const localInfo: any = localInfoStr ? JSON.parse(localInfoStr) : null;
      if (this.channel == "shunwan") {
        window.location.href = localInfo
          ? localInfo.shunwan.pc_down_url
          : this.$store.state.home.downList.shunwan.pc_down_url;
      } else if (this.channel == "996") {
        window.location.href = localInfo
          ? localInfo.channel_996.pc_down_url
          : this.$store.state.home.downList.channel_996.pc_down_url;
      } else {
        window.location.href = localInfo
          ? localInfo.pc_down_url
          : this.$store.state.home.downList.pc_down_url;
      }
    } else {
      this.pcModalBtnStr = "Mac";
      this.modelShow = false;
      this.pcModalTip = true;
    }
    if (!download) this.eventReporting(1);
  }
  public downLoadMac(download) {
    if (this.os === "Mac" || download) {
      window.location.href =
        "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg";
    } else {
      this.pcModalBtnStr = "Windows";
      this.modelShow = false;
      this.pcModalTip = true;
    }
    if (!download) this.eventReporting(2);
  }
  public downLoadAndroid() {
    const localInfoStr: any = localStorage.getItem("LOCAL_BOXDOWNLOADURL");
    const localInfo: any = localInfoStr ? JSON.parse(localInfoStr) : null;
    if (this.channel == "shunwan") {
      window.location.href = localInfo
        ? localInfo.shunwan.android_down_url
        : this.$store.state.home.downList.shunwan.android_down_url;
    } else if (this.channel == "996") {
      window.location.href = localInfo
        ? localInfo.channel_996.android_down_url
        : this.$store.state.home.downList.channel_996.android_down_url;
    } else {
      window.location.href = localInfo
        ? localInfo.android_down_url
        : this.$store.state.home.downList.android_down_url;
    }
    this.eventReporting(3);
  }
  public ortherVersionDownload() {
    this.pcModalTip = false;
    if (this.pcModalBtnStr === "Windows") this.downLoadWindows(true);
    if (this.pcModalBtnStr === "Mac") this.downLoadMac(true);
    this.pcModalBtnStr = "Windows";
  }
  public continueDownload() {
    this.pcModalTip = false;
    if (this.pcModalBtnStr === "Windows") this.downLoadMac(true);
    if (this.pcModalBtnStr === "Mac") this.downLoadWindows(true);
    this.pcModalBtnStr = "Windows";
  }
  public onCancel() {
    this.modelShow = true;
  }
  public getQrcode(id, url) {
    const routeUrl = new QRCode(id, {
      width: 100,
      height: 100,
      text: url,
    });
    routeUrl._el.title = "";
  }
}
